import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useForm, SubmitHandler } from 'react-hook-form';
import React, { useState, useEffect } from 'react';

import { registerUser, resetAuth } from '../../core/data/redux/action';

import { all_routes } from '../router/all_routes';
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath';

import { AppDispatch } from '../../core/data/redux/store';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../core/data/redux/store';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Lottie from 'lottie-react';
import Loader from '../../core/data/img/car_loading.json';

type FormValues = {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  password_confirmation: string;
  country_code: string;
  mobile: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  is_sms_alert_approved: boolean;
};

const routes = all_routes;
const SignUp = () => {
  const [isToggle, setIsToggle] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { loading, location_address, user, success, error } = useSelector(
    (state: RootState) => ({
      success: state.auth.success,
      user: state.auth.user,
      error: state.auth.error,
      location_address: state.auth.location_address,
      loading: state.auth.loading,
    })
  );

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getParam = (key: string) => {
    const value = queryParams.get(key);
    return value ? decodeURIComponent(value) : null;
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
    setValue,
  } = useForm<FormValues>({
    defaultValues: {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      password_confirmation: '',
      country_code: '+1',
      mobile: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      is_sms_alert_approved: false,
    },
  });

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    dispatch(
      registerUser({
        ...data,
        is_sms_alert_approved: data?.is_sms_alert_approved?1:0,
        location_id: getParam('location'),
      })
    );
  };

  useEffect(() => {
    dispatch(resetAuth());
  }, []);

  const extractLocationDetails = (address: string) => {
    if (address) {
      const parts = address?.split(',').map((part) => part.trim());

      // Extract relevant parts
      const pincode = parts.find((part) => /^\d{6}$/.test(part)); // 6-digit pincode
      const country = parts[parts.length - 1];
      const state = parts[parts.length - 3];
      const city = parts[parts.length - 4];

      return { country, city, state, pincode };
    }

    return { country: 'USA', city: '', state: '', pincode: '' };
  };

  useEffect(() => {
    const details = extractLocationDetails(location_address);

    setValue('city', details.city ?? '');
    setValue('zip', details.pincode ?? '');
    setValue('state', details.state ?? '');

    setValue('address', location_address ?? '');
  }, [location_address]);

  // const getAddress = () => {
  //   dispatch(getAddressFromCoords());
  // }

  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');

  useEffect(() => {
    if (user && success) {
      showToast(success);
      navigate(routes.userBookings);
      reset();
      dispatch(resetAuth());
    } else if (success) {
      showToast(success);
      navigate(routes.login);
      reset();
      dispatch(resetAuth());
    } else if (error) {
      showToast(error);
      dispatch(resetAuth());
      // reset();
    }
  }, [user, success, error]);

  const showToast = (message: any) => {
    setToastClass(error ? 'bg-danger text-white' : 'bg-success text-white');

    setToastMessage(message);
  };

  const handleCloseToast = () => {
    setToastMessage('');
  };

  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      } else {
        toast.success(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      }
    }
  }, [toastMessage, toastClass]);

  return (
    <div>
      <div className="main-wrapper login-body">
        {/* Header */}
        <header className="log-header">
          <Link to={routes.homeOne}>
            <ImageWithBasePath
              className="img-fluid logo-dark"
              src="assets/img/logo/fairRentallogo.png"
              alt="Logo"
            />
          </Link>
        </header>

        {toastMessage && <ToastContainer autoClose={3000} />}
        {/* /Header */}
        <div className="login-wrapper">
          <div className="loginbox">
            <div className="login-auth pt-0">
              <div className="login-auth-wrap">
                {/* <div className="sign-group">
                  <Link to={routes.homeOne} className="border-0 text-primary-dark d-flex align-items-center mb-0">
                    <i className="bx bx-arrow-back fs-5 me-2"></i>
                    <span className="mt-1"> Back To Home </span>
                  </Link>
                </div> */}
                <h1 className="text-center">Sign Up</h1>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="d-flex gap-2">
                    {/* Name */}
                    <div className="input-block flex-fill">
                      <label className="form-label  mb-1">
                        First name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}
                        {...register('first_name', {
                          required: 'First Name is required',
                        })}
                      />
                      {/* {errors.first_name && <p className="text-danger">{errors.first_name.message}</p>} */}
                    </div>

                    <div className="input-block  flex-fill">
                      <label className="form-label mb-1">Last name </label>
                      <input
                        type="text"
                        className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}
                        {...register('last_name')}
                      />
                      {/* {errors.last_name && <p className="text-danger">{errors.last_name.message}</p>} */}
                    </div>
                  </div>

                  <p className="fs-13">
                    Enter your name as it appears on your driver’s license
                  </p>
                  <div className="d-flex gap-2">
                    {/* Email */}
                    <div className="input-block  flex-fill">
                      <label className="form-label mb-1">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                        {...register('email', {
                          required: 'Email is required',
                        })}
                      />
                      {/* {errors.email && <p className="text-danger">{errors.email.message}</p>} */}
                    </div>
                    <div className="input-block flex-fill">
                      <label className="form-label  mb-1 ">
                        Mobile <span className="text-danger">*</span>
                      </label>
                      <div className="d-flex">
                        <input
                          type="number"
                          className={`form-control mb-0 ${errors.mobile ? 'is-invalid' : ''}`}
                          {...register('mobile', {
                            required: 'Mobile number is required',
                          })}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex gap-2">
                    {/* Password */}
                    <div className="input-block  flex-fill">
                      <label className="form-label mb-1">
                        Password <span className="text-danger">*</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={isToggle ? 'text' : 'password'}
                          className={`form-control pass-input ${errors.password ? 'is-invalid' : ''}`}
                          {...register('password', {
                            required: 'Password is required',
                          })}
                        />
                        <span
                          onClick={() => setIsToggle(!isToggle)}
                          className={`fas toggle-password ${isToggle ? 'fa-eye' : 'fa-eye-slash'}`}
                        />
                      </div>
                      {/* {errors.password && <p className="text-danger">{errors.password.message}</p>} */}
                    </div>

                    <div className="input-block  flex-fill">
                      <label className="form-label  mb-1">
                        Confirm Password <span className="text-danger">*</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={isToggle ? 'text' : 'password'}
                          className={`form-control pass-input ${errors.password_confirmation ? 'is-invalid' : ''}`}
                          {...register('password_confirmation', {
                            required: 'Confirm Password is required',
                            validate: (value) =>
                              value === watch('password') ||
                              'Passwords do not match',
                          })}
                        />
                        <span
                          onClick={() => setIsToggle(!isToggle)}
                          className={`fas toggle-password ${isToggle ? 'fa-eye' : 'fa-eye-slash'}`}
                        />
                      </div>
                    </div>
                  </div>

                  {
                    <p className="">
                      {' '}
                      <span className="text-danger">*</span>
                      {' Password should be miminmu 6 character'}
                    </p>
                  }

                  <div className="col-md-12 mt-1 mb-2">
                    <div className="input-block m-0">
                      <label className="custom_check d-inline-flex location-check m-0">
                        <span>
                          <small className="text-sm  ">
                            <p>
                              Yes, I’d like to receive SMS alerts from Fairental
                              for booking confirmations, payment updates,
                              support messages, and important reminders.
                            </p>
                          </small>
                          <small className="text-sm  ">
                            <i>
                              <p>
                                {' '}
                                Message and data rates may apply. Reply STOP to
                                unsubscribe.{' '}
                              </p>
                            </i>
                          </small>
                        </span>

                        <input
                          type="checkbox"
                          className={`form-control mb-0 ${errors.is_sms_alert_approved ? 'is-invalid' : ''}`}
                          {...register('is_sms_alert_approved')}
                        />
                        <span
                          style={{ padding: 5 }}
                          className={`checkmark form-control ${errors.is_sms_alert_approved ? 'is-invalid' : ''}`}
                        />
                      </label>
                    </div>
                  </div>

                  {/* Country Code + Mobile Number */}
                  {/* <div className="col-md-12 py-2">
                    <div className="input-block m-0">
                      <label className="custom_check d-inline-flex location-check m-0">
                        <span data-bs-toggle="modal" className="fs-13">
                          I agree to the terms of <u>service</u> and <u>privacy policy</u>. <span className="ms-1 text-danger"> *</span>
                        </span>

                        <input type="checkbox"   {...register("terms_conditions", { required: "Terms conditions is required" })}
                          checked={watch("terms_conditions")} className={`checkmark form-control   ${errors?.terms_conditions ? "is-invalid" : ""}`} />
                        <span style={{ padding: 5 }} className={`checkmark form-control   ${errors?.terms_conditions ? "is-invalid" : ""}`} />
                      </label>
                    </div>
                  </div> */}

                  {/* <div className="col-md-12 py-2">
                    <div className="input-block m-0">
                      <label className="custom_check d-inline-flex location-check m-0">
                        <span className="fs-13"> Send me promotions and announcements via email</span>
                        <input type="checkbox" {...register("promotion")} checked={watch("promotion")} className={`checkmark form-control   ${errors?.promotion ? "is-invalid" : ""}`} />
                        <span style={{ padding: 5 }} className={`checkmark form-control   ${errors?.promotion ? "is-invalid" : ""}`} />
                      </label>
                    </div>
                  </div> */}

                  {/* Submit Button */}
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <Lottie
                        animationData={Loader}
                        loop={true}
                        style={{ width: 100, height: 100 }}
                      />
                    </div>
                  ) : (
                    <button
                      type="submit"
                      disabled={loading}
                      className="btn btn-primary w-100 btn-size mt-1 py-2"
                    >
                      {'Sign Up'}
                    </button>
                  )}

                  {/* <div className="login-or d-flex  py-1 justify-content-center "> 
                  <span className="span-or-log">Or, log in with your email</span>
                </div> */}

                  {/* Social Login */}
                  {/* <div className="social-login">
                    <button type="button" className="d-flex align-items-center justify-content-center input-block btn google-login w-100">
                      <span><GoogleLoginComponent /></span>
                    </button>
                  </div> */}

                  <div className="text-center dont-have mt-3">
                    Already have an Account?{' '}
                    <Link to="/authentication/login">Sign In</Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <footer className="log-footer">
          <div className="container-fluid">
            {/* Copyright */}
            <div className="copyright">
              <div className="copyright-text">
                <p>© 2025 FaiRental. All Rights Reserved.</p>
              </div>
            </div>
            {/* /Copyright */}
          </div>
        </footer>
        {/* /Footer */}
      </div>
    </div>
  );
};

export default SignUp;
